/* eslint-disable no-unused-vars */
import { FunctionComponent, useState } from "react";
import LoginStyles from "./login.module.css";
import { Button } from "primereact/button";
import Logo from "assets/adroit_logo.png";
import { IUser } from "types/user.type";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { setToaster } from "common/toastStore";
import AuthService from "services/AuthService";
import { useNavigate } from "react-router-dom";
import Loader from "common/Loader";

interface LoginProps {}

const ForgotPassword: FunctionComponent<LoginProps> = () => {
  let navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const [inputValue, setInputValue] = useState<IUser>({
    email: "",
  });
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setInputValue({
      ...value,
      [name]: value,
    });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Enter a valid email address")
      .required("Email is required"),
  });

  const formOptions = {
    resolver: yupResolver(validationSchema),
    mode: "onBlur",
  };
  const { register, handleSubmit, formState, setValue, trigger } =
    useForm<IUser>(formOptions as object);
  const { errors, isValid } = formState;

  const onSubmit = (data: IUser) => {
    if (isValid) {
      setLoading(true);
      AuthService.passwordReset(data?.email).then(
        (_response) => {
          setToaster({
            severity: "success",
            summary: "Success Message",
            detail:
              "A password reset link has been sent to your registered email.",
          });
          setLoading(false);
        },
        (error) => {
          console.log(error);
          setToaster({
            severity: "error",
            summary: "Error Message",
            detail: error.response.data[0],
          });
          setLoading(false);
        }
      );
    }
  };

  const forgotPasswordRedirect = () => {
    navigate("/login", { replace: true });
  };

  return (
    <>
      <div className={LoginStyles.login_bg}>
        <form name="" onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-6 flex justify-center">
            <img src={Logo} alt="" />
          </div>
          <div className="bg-white w-96 rounded-2xl	p-6 shadow-lg">
            <p className="text-center text-md	font-medium py-1">
              Forgot your password? Reset it here.
            </p>
            <div className="my-8 relative z-0 w-full ">
              <div className="p-float-label">
                <InputText
                  id="email"
                  {...register("email")}
                  name="email"
                  onChange={handleChange}
                  className="w-full text-sm"
                />
                <label htmlFor="userName">Enter Email ID</label>
              </div>
              <div className="text-xs text-red-900">
                {errors?.email?.message}
              </div>
            </div>

            <div className="">
              <Button
                label="Submit"
                type="submit"
                className={LoginStyles.login_submit}
              />
            </div>
            <div className="my-4">
              <span
                className="text-sm text-right block cursor-pointer underline"
                onClick={() => {
                  forgotPasswordRedirect();
                }}
              >
                Login
              </span>
            </div>
          </div>
        </form>
      </div>
      {loading ? <Loader /> : null}
    </>
  );
};

export default ForgotPassword;
